import { Suspense } from 'react';
import { ResetPasswordForm } from '@/platform/auth/reset-password-form';
import { AmbientBackground } from '@/platform/ui/ambient-background';

export default function ResetPasswordPage() {
  return (
    <>
      <AmbientBackground />
      <div className="flex min-h-screen items-center justify-center p-4">
        <Suspense fallback={
          <div className="animate-pulse text-muted-foreground">Loading...</div>
        }>
          <ResetPasswordForm />
        </Suspense>
      </div>
    </>
  );
}
